/** Integração com o Autonomous (revisão da fase 1): textos novos fora de shell.ts, para não conflitar com os outros itens. */
const en = {
  'auto.push.title': 'Autonomous notifies people in this installation',
  'auto.push.text':
    'This installation is integrated with Autonomous: Hive no longer sends alert notifications to phones and computers. Autonomous receives every alert and decides who to notify. Your devices stay registered and receive notifications again if the integration is turned off.',
};

type K = keyof typeof en;

const ptBR: Record<K, string> = {
  'auto.push.title': 'Nesta instalação quem avisa as pessoas é o Autonomous',
  'auto.push.text':
    'Esta instalação está integrada ao Autonomous: o Hive não manda mais notificações de alerta ao celular e ao computador. O Autonomous recebe todos os alertas e decide quem avisar. Os seus aparelhos continuam cadastrados e voltam a receber se a integração for desligada.',
};

const es: Record<K, string> = {
  'auto.push.title': 'En esta instalación quien avisa a las personas es Autonomous',
  'auto.push.text':
    'Esta instalación está integrada con Autonomous: Hive ya no envía notificaciones de alertas al celular ni a la computadora. Autonomous recibe todas las alertas y decide a quién avisar. Sus dispositivos siguen registrados y vuelven a recibirlas si se desactiva la integración.',
};

export const autonomousMessages = { en, 'pt-BR': ptBR, es } as const;
